import React from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

const logo = require('../assets/final_logo.png');

function Navbar() {
  return (
    <nav className="nav">
      <Link to="/" className="nav__brand">
        <img src={logo} alt="Afraz logo" className="nav__logo" />
        <span className="nav__name">Afraz Khan</span>
      </Link>

      <div className="nav__links">
        <Link to="/" className="nav__link">
          Home
        </Link>
        <Link to="/projects" className="nav__link">
          Projects
        </Link>
        <Link to="/experience" className="nav__link">
          Experience
        </Link>
        <Link to="/blog" className="nav__link">
          Blog
        </Link>
        <Link to="/resume" className="nav__btn">
          Resume
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
